import React, { Component } from "react";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { connect } from "react-redux";
import { isDataValidForPurchaseOrBuild } from "../util/fetch/isDataValidForPurchaseOrBuild";
import { PURCHASEIRQCompareView } from "../views/PURCHASEIRQCompareView";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { purchaseComparePageValidationSchema } from "../util/comparePageValidationSchema";
import EditableDataContainer from "../containers/EditableDataContainer";
import { mapPageToProps } from "../util/mapPageToProps";
import { LoadingIndicator } from "../atoms/LoadingIndicator";
import { FastTrackView } from "../views/FastTrackView";
import { withToastContext } from "../util/withToastContext";
import { processQuoteResult } from "../util/fetch/processQuoteResult";
import { fastTrackValidationSchema } from "../util/fastTrackValidationSchema";
import { isPlannedClosingDateLessThanThirteenDaysAway } from "../util/fetch/isPlannedClosingDateLessThanThirteenDaysAway";
import { getParametizedQuoteEndpoint } from "../util/fetch/getParametizedQuoteEndpoint";
import { LookingToContext } from "../context/LookingToContext";
import StatusCheck from "../components/StatusCheck";
import { CountyLimitsContext } from "../context/CountyLimitsContext";

class PurchaseIrqComparePage extends Component {
  static contextType = CountyLimitsContext;

  constructor() {
    super();
    this.state = {
      quotes: null,
      insufficientData: null,
      lookingTo: "Purchase",
    };
    this.runQuotesQuery = this.runQuotesQuery.bind(this);
    this.getPageData = this.getPageData.bind(this);
  }

  componentDidMount() {
    if (!isDataValidForPurchaseOrBuild(this.props.data)) {
      this.setState({ insufficientData: true });
      if (
        isPlannedClosingDateLessThanThirteenDaysAway(
          this.props.data.plannedClosingDate
        )
      ) {
        this.props.toastContext.openToast({
          message:
            "You must select a planned closing date more than 15 days away.",
        });
      }
      this.context.fetchCountyLimits();
      return;
    }

    this.getPageData();
  }

  getPageData = async () => {
    await this.context.fetchCountyLimits();
    this.runQuotesQuery(
      this.props.data.lookingTo ?? "Purchase",
      this.props.data
    );
  };

  runQuotesQuery = (lookingTo, data) => {
    this.setState({ lookingTo });
    const parametizedQuoteEndpoint = getParametizedQuoteEndpoint(
      lookingTo,
      data
    );
    return processQuoteResult.call(this, parametizedQuoteEndpoint);
  };

  render() {
    const { countyLimits } = this.context;

    if (countyLimits === null) {
      return (
        <div className="page-wrapper">
          <LoadingIndicator label="Fetching page data..." />
        </div>
      );
    }

    if (this.state.insufficientData === null) {
      return (
        <div className="page-wrapper">
          <LoadingIndicator label="Fetching loan options..." />
        </div>
      );
    }

    if (this.state.insufficientData === true) {
      return (
        <div className="page-wrapper">
          <StatusCheck />
          <LookingToContext.Provider value={this.state.lookingTo}>
            <EditableDataContainer
              id="purchaseIrq"
              mutateRedux="always"
              validationSchema={fastTrackValidationSchema}
              isStep
            >
              <FastTrackView
                runQuotesQuery={this.runQuotesQuery}
                content={contentMap.PurchaseIrqComparePage}
                navigationsAway={customNavigationMap.PurchaseIrqComparePage}
              />
            </EditableDataContainer>
          </LookingToContext.Provider>
        </div>
      );
    }

    return (
      <div className="page-wrapper">
        <LookingToContext.Provider value={this.state.lookingTo}>
          <EditableDataContainer
            id="purchaseIrq"
            mutateRedux="always"
            validationSchema={purchaseComparePageValidationSchema}
            isStep
          >
            <PURCHASEIRQCompareView
              runQuotesQuery={this.runQuotesQuery}
              quotes={this.state.quotes}
              content={contentMap.PurchaseIrqComparePage}
              navigationsAway={customNavigationMap.PurchaseIrqComparePage}
            />
          </EditableDataContainer>
        </LookingToContext.Provider>
      </div>
    );
  }
}

export default connect(mapPageToProps("purchaseIrq"))(
  withToastContext(withRouterUtilities(PurchaseIrqComparePage))
);
